import { API, graphqlOperation } from "aws-amplify"
import {
	LOGIN_FB,
	LOGIN_GM,
	LOGIN_LN,
	LOGIN_LOCAL,
	LOGOUT_LOCAL,
	RESTORE_SESSION,
	UPDATE_USER_ATTRIBS,
	SIGNUP_USER,
	NEWPASSWORD_REQ,
	FORGOT_PASSWORD,
	RESET_PASSWORD,
	RESEND_VARIFICATION,
	ADD_USER_OBJECTS,
	CHANGE_PASSWORD,
	GET_USER,
	CREATE_USER,
	UPDATE_USER,
	UPLOAD_PROFILE_IMAGE,
	FAVORITE_PROJECT,
	FOLLOW_USER,
	WRITE_RATING,
	GET_RATING,
	UPDATE_RATING,
	SEND_EMAIL,
	UPDATE_LATEST_LOGIN
} from "../ActionTypes"
import {
	handlefb,
	handlegm,
	handleln,
	handleloginlocal,
	handlelogoutlocal,
	handlerestoreSession,
	handleupdateuserattribute,
	handlesignupuser,
	handlenewpasswordreq,
	handleforgotpassword,
	handleresetpassword,
	handleresendverification,
	handleuserobject,
	handlechangepassword
} from "../FunctionAction/function.user"
import { uploadImage } from "../FunctionAction/function.file"
import {
	createUser,
	updateUser,
	addfavoriteProject,
	followUser,
	writeRating,
	updateRating,
	sendEmail,
	updateUserLatestLogin
} from "../graphql/mutation"
import { getRating } from "../graphql/queries"
import { get_user_function } from "../containers/Function/OtherUserInfo.function"

export const login_fb = (data) => ({
	type: LOGIN_FB,
	payload: handlefb(data)
})

export const login_gm = (data) => ({
	type: LOGIN_GM,
	payload: handlegm(data)
})

export const login_ln = (data) => ({
	type: LOGIN_LN,
	payload: handleln(data)
})

export const login_local = (email, password, t) => ({
	type: LOGIN_LOCAL,
	payload: handleloginlocal(email, password, t)
})

export const logout_local = () => ({
	type: LOGOUT_LOCAL,
	payload: handlelogoutlocal()
})

export const restoreSession = () => ({
	type: RESTORE_SESSION,
	payload: handlerestoreSession()
})

export const signup_user = (data, t) => ({
	type: SIGNUP_USER,
	payload: handlesignupuser(data, t)
})

export const newpassword_req = (data, newpassword) => ({
	type: NEWPASSWORD_REQ,
	payload: handlenewpasswordreq(data, newpassword)
})

export const forgot_password = (username) => ({
	type: FORGOT_PASSWORD,
	payload: handleforgotpassword(username)
})

export const reset_password = (username, code, new_password) => ({
	type: RESET_PASSWORD,
	payload: handleresetpassword(username, code, new_password)
})

export const resend_verification = (username) => ({
	type: RESEND_VARIFICATION,
	payload: handleresendverification(username)
})

export const updateUserAttributes = (info) => ({
	type: UPDATE_USER_ATTRIBS,
	payload: handleupdateuserattribute(info)
})
export const userobject = () => ({
	type: ADD_USER_OBJECTS,
	payload: handleuserobject()
})

export const changepassword = (data) => ({
	type: CHANGE_PASSWORD,
	payload: handlechangepassword(data)
})

export const get_user = (user_id, user) => ({
	type: GET_USER,
	payload: get_user_function(user_id, user)
})

export const create_user = (data) => ({
	type: CREATE_USER,
	payload: API.graphql(graphqlOperation(createUser, data))
})

export const update_user = (data) => ({
	type: UPDATE_USER,
	payload: API.graphql(graphqlOperation(updateUser, data))
})

export const update_latest_login = (data) => ({
	type: UPDATE_LATEST_LOGIN,
	payload: API.graphql(graphqlOperation(updateUserLatestLogin))
})

export const upload_image = (image) => (dispatch) =>
	dispatch({
		type: UPLOAD_PROFILE_IMAGE,
		payload: uploadImage(image)
			.then((data) => {
				dispatch(update_user({ profile_picture: data }))
				return data
			})
			.catch((err) => {})
	})

export const addfavoriteproject = (project_id, added) => ({
	type: FAVORITE_PROJECT,
	payload: API.graphql(graphqlOperation(addfavoriteProject(project_id, added)))
})

export const follow_user = (user_id, follow) => ({
	type: FOLLOW_USER,
	payload: API.graphql(graphqlOperation(followUser(user_id, follow)))
})

export const write_Rating = (data) => ({
	type: WRITE_RATING,
	payload: API.graphql(graphqlOperation(writeRating(data)))
})

export const get_Rating = (rating_type, project_id, user_id) => ({
	type: GET_RATING,
	payload: API.graphql(
		graphqlOperation(getRating(rating_type, project_id, user_id))
	)
})

export const update_Rating = (data) => ({
	type: UPDATE_RATING,
	payload: API.graphql(graphqlOperation(updateRating(data)))
})

export const send_email = (data) => ({
	type: SEND_EMAIL,
	payload: API.graphql(graphqlOperation(sendEmail, data))
})
